import { render, staticRenderFns } from "./ApproachedSummary.vue?vue&type=template&id=4364f1cc"
import script from "./ApproachedSummary.vue?vue&type=script&lang=js"
export * from "./ApproachedSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports